import { render, staticRenderFns } from "./index.vue?vue&type=template&id=edfccdb6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../style.scss?vue&type=style&index=0&id=edfccdb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfccdb6",
  null
  
)

export default component.exports